import { z } from 'zod'

export const COACHING_SHELL_PROGRAM_CONTRACT_VERSION = '1.0.0' as const
export const coachingShellProgramResponseSchema = z.unknown()
export type CoachingShellProgramResponse = z.infer<typeof coachingShellProgramResponseSchema>
